<template>
  <div>
    <v-card>
      <v-card-title> محاسبات شارژ اعتبار </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <service-prices-list></service-prices-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ServicePricesList from '../components/ServicePricesList.vue';

export default {
  data() {
    return {};
  },
  components: {
    ServicePricesList,
  },
  methods: {},
};
</script>

<style></style>
